import i18n from '@/lang';

const processTypes = {
  FT: {
    val: 1,
    explain: '测试',
    startDevicen: 'AS/D/D/G',
    endDevicen: 'FT/D/D/G',
  },
  FRL: {
    val: 2,
    explain: '测编',
    startDevicen: 'AS/D/D/G',
    endDevicen: 'FRT/D/D/G',
  },
};

const priorityLevels = {
  high: {
    color: '#C32D2B',
    val: 3,
    explain: i18n.t('priorityLevel.urgent'),
  },
  mid: {
    color: '#D5632C',
    val: 2,
    explain: i18n.t('priorityLevel.important'),
  },
  low: {
    color: '#25CB7A',
    val: 1,
    explain: i18n.t('priorityLevel.commonly'),
  },
};

const storeStatus = {
  //来料订单:未入库 已入库 已出库（已出库一个箱子）已发货(已发货一个成品箱子，置为已发货) 已完成 (来料订单完成时更新)
  //来料箱子:未入库 已入库 已出库
  //来料盒子:未入库 已入库 已出库
  //成品订单:已入库 已发货 已完成
  //成品箱子:未入库 已入库 已发货
  //成品盒子:未入库 已入库 已发货
  noReceipt: {
    val: 0,
    explain: '未入库',
    remarks: '',
  },
  received: {
    val: 2,
    explain: '已入库',
    remarks: '',
  },
  delivery: {
    val: 3,
    explain: '已出库',
    remarks: '准备测试',
  },
  send: {
    val: 5,
    explain: '已发货',
    remarks: '来料订单，成品库存，发货订单',
  },
  finished: {
    val: 6,
    explain: '已结束',
    remarks: '',
  },
  canBeSent: {
    val: 7,
    explain: '已关联箱子',
  },
  notFinished: {
    val: 8,
    transformaVal: [0, 2, 3, 5],
    explain: '非已完成状态',
  },
  canbeDelivered: {
    val: 11,
    explain: '可以被发货的来料订单，条件：来料订单中incoCount>finishCount>0',
  },
  valid: [0, 2, 3, 5, 6, 8],
};

const incomingOrderStatus = { // 来料订单:未入库 已入库 已出库（已出库一个箱子）已发货(已发货一个成品箱子，置为已发货) 已完成 (来料订单完成时更新)
  noReceipt: {
    val: 0,
    explain: '未入库',
    remarks: '',
  },
  received: {
    val: 2,
    explain: '已入库',
    prodOderExplain: '未发货',
    remarks: '',
  },
  delivery: {
    val: 3,
    explain: '已出库',
    remarks: '准备测试',
  },
  send: {
    val: 5,
    explain: '已发货',
    remarks: '来料订单，成品库存，发货订单',
  },
  finished: {
    val: 6,
    explain: '已结束',
    remarks: '',
  },
};

const incomeStorageStatus = { //来料箱子:未入库 已入库 已出库
  noReceipt: {
    val: 0,
    explain: '未入库',
    remarks: '',
  },
  received: {
    val: 2,
    explain: '已入库',
    prodOderExplain: '未发货',
    remarks: '',
  },
  delivery: {
    val: 3,
    explain: '已出库',
    remarks: '准备测试',
  },
};

const storeBoxStatus = { // 成品箱子
  noReceipt: {
    val: 0,
    explain: '未入库',
    remarks: '',
  },
  received: {
    val: 2,
    explain: '已入库',
    remarks: '',
  },
  send: {
    val: 5,
    explain: '已发货',
    remarks: '来料订单，成品库存，发货订单',
  },
};

const prodOrderStatus = {
  received: {
    val: 2,
    explain: '待发货',
    remarks: '',
  },
  send: {
    val: 5,
    explain: '已发货',
    remarks: '来料订单，成品库存，发货订单',
  },
  finished: {
    val: 6,
    explain: '已结束',
    remarks: '',
  },
};

const orderOprTypes = {
  import: {
    val: 1,
    explain: '录入',
  },
  entry: {
    val: 2,
    explain: '入库',
  },
  delivery: {
    val: 3,
    explain: '出库',
  },
  return: {
    val: 4,
    explain: '退库',
  },
  calcelentry: {
    val: 5,
    explain: '取消入库',
  },
};

const expressages = {
  // 指定快递公司
  SF: {
    val: 'SF',
    explain: '顺丰速运',
  },
  EMS: {
    val: 'EMS',
    explain: 'EMS',
  },
};

const expressageTypes = {
  // 指定快递方式
  express: {
    val: 'express',
    explain: '快递',
  },
  airExpress: {
    val: 'airExpress',
    explain: '空运快递',
  },
  logistics: {
    val: 'logistics',
    explain: '物流',
  },
};

const passBinLevels = [{
  val: 1,
  explain: 1
}, {
  val: 2,
  explain: 2
}, {
  val: 3,
  explain: 3
}, {
  val: 4,
  explain: 4
}];

const binLevelExplainData = [{
  val: '',
  explain: '无'
}, {
  val: 'A',
  explain: 'A'
}];

const partNoSuffixes = [{
  label: '无',
  value: ''
}, {
  label: 'TR',
  value: 'TR'
}];

const explainArray = [{
  label: '视检不良',
  value: '视检不良'
}, {
  label: '电检不良',
  value: '电检不良'
}];

const labelTypes = [{
  val: 1,
  chinese: '视芯',
  hasBoxLabel: false,
}, {
  val: 2,
  chinese: '元亨',
  hasBoxLabel: true,
}, {
  val: 3,
  chinese: '强力',
  hasBoxLabel: false,
}, {
  val: 4,
  chinese: '利亚德',
  hasBoxLabel: false,
}, {
  val: 5,
  chinese: '利亚德电视',
  hasBoxLabel: false,
}, {
  val: 6,
  chinese: '易事达',
  hasBoxLabel: false,
}, {
  val: 7,
  chinese: '巴科',
  hasBoxLabel: false,
}, {
  val: 8,
  chinese: '惠州雷曼',
  hasBoxLabel: false,
}, {
  val: 9,
  chinese: '惠州健和',
  hasBoxLabel: true,
}, {
  val: 10,
  chinese: '美卡乐',
  hasBoxLabel: false,
}, {
  val: 11,
  chinese: '金立翔',
  hasBoxLabel: false,
}, {
  val: 12,
  chinese: '强力巨彩V2',
}, {
  val: 13,
  chinese: '视芯(重打)', //绍兴以外的标签，重打
}, {
  val: 14,
  chinese: '强力外箱加贴',
}, {
  val: 15,
  chinese: '惠州联建',
}, {
  val: 16,
  chinese: '晶圆袋',
}, {
  val: 17,
  chinese: '晶圆角',
}, {
  val: 18,
  chinese: '晶圆箱',
}, {
  val: 19,
  chinese: '袋上的标签/B袋',
}, {
  val: 20,
  chinese: '蓝膜上的标签',
}, {
  val: 21,
  chinese: '箱上的标签',
}, {
  val: 22,
  chinese: '袋上的标签/C袋',
}, {
  val: 23,
  chinese: '模块编号',
}, {
  val: 24,
  chinese: '视芯标签升级'
}, {
  val: 25,
  chinese: '花蓝标签'
}, {
  val: 26,
  chinese: '晶台标签',
}];

const definedLabelType = {
  shixin: {
    val: 1,
    chinese: '视芯',
  },
  yuanheng: {
    val: 2,
    chinese: '元亨',
  },
  qiangli: {
    val: 3,
    chinese: '强力巨彩',
  },
  qiangli_v2: {
    val: 12,
    chinese: '强力巨彩V2',
  },
  qiangli_box: {
    val: 14,
    chinese: '强力外箱加贴',
  },
  liyade: {
    val: 4,
    chinese: '利亚德',
  },
  liyadedianshi: {
    val: 5,
    chinese: '利亚德电视',
  },
  yishida: {
    val: 6,
    chinese: '易事达',
  },
  bake: {
    val: 7,
    chinese: '巴科',
  },
  leiman: {
    val: 8,
    chinese: '惠州雷曼',
  },
  jianhe: {
    val: 9,
    chinese: '惠州健和',
  },
  meikale: {
    val: 10,
    chinese: '美卡乐',
  },
  // 与liyade相同
  jinlixiang: {
    val: 11,
    chinese: '金立翔',
  },
  shixin2: {
    val: 13,
    chinese: '视芯(重打)', //绍兴以外的标签，重打
  },
  lianjian: {
    val: 15,
    chinese: '惠州联建',
  },
  jingyuan_dai: {
    val: 16,
    chinese: '晶圆袋',
  },
  jingyuan_pian: {
    val: 17,
    chinese: '晶圆角',
  },
  jingyuan_box: {
    val: 18,
    chinese: '晶圆箱',
  },
  bag: {
    val: 19,
    chinese: '袋上的标签/B袋',
  },
  membrane: {
    val: 20,
    chinese: '蓝膜上的标签',
  },
  case: {
    val: 21,
    chinese: '箱上的标签',
  }, 
  bagC: {
    val: 22,
    chinese: '袋上的标签/C袋',
  }, 
  moduleNo: {
    val: 23,
    chinese: '模块编号',
  },
  shixinV2: {
    val: 24,
    chinese: '视芯标签升级'
  },
  hualan: {
    val: 25,
    chinese: '花蓝标签'
  },
  jingtai: {
    val: 26,
    chinese: '晶台标签',
  }
};

const boxLabelTypes = {
  boxLabel: {
    val: 1,
    chinese: '箱',
  },
  plateLabel: {
    val: 2,
    chinese: '盘',
  },
  caseLabel: {
    val: 3,
    chinese: '盒',
  }
};

const definedFactoryLabelParameter = {
  [definedLabelType.yuanheng.val]:
    ['productName', 'chipName', 'processingOrderNo', 'purchaseOrderNo', 'customPartNo', 'partNo', 'dateCode', 'trackingNo', 'qty', 'reserve'],
  [definedLabelType.qiangli.val]:
    ['productName', 'chipName', 'partNo', 'customPartNo', 'purchaseOrderNo', 'qty', 'grossWeight', 'dateCode', 'trackingNo'],
  [definedLabelType.liyade.val]:
    ['productName', 'chipName', 'purchaseOrderNo', 'customPartNo', 'partNo', 'qty', 'dateCode', 'lotNo'],
  [definedLabelType.liyadedianshi.val]:
    ['productName', 'chipName', 'purchaseOrderNo', 'customPartNo', 'partNo', 'qty', 'dateCode', 'lotNo'],
  [definedLabelType.yishida.val]:
    ['productName', 'chipName', 'purchaseOrderNo', 'customPartNo', 'qty'],
  [definedLabelType.bake.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'dateCode', 'packageType', 'marking', 'binLevel', 'result', 'grossWeight', 'netWeight', 'customPartNo', 'reserve'],
  [definedLabelType.leiman.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'dateCode', 'packageType', 'marking', 'binLevel', 'result', 'grossWeight', 'netWeight', 'customPartNo', 'reserve'],
  [definedLabelType.jianhe.val]:
    ['productName', 'chipName', 'customPartNo', 'partNo', 'purchaseOrderNo', 'dateCode'],
  [definedLabelType.meikale.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'dateCode', 'packageType', 'marking', 'binLevel', 'result', 'grossWeight', 'netWeight', 'customPartNo', 'reserve'],
  [definedLabelType.jinlixiang.val]:
    ['productName', 'chipName', 'purchaseOrderNo', 'customPartNo', 'partNo', 'qty', 'dateCode', 'lotNo'],
  [definedLabelType.qiangli_v2.val]:
    ['productName', 'chipName', 'processingOrderNo', 'partNo', 'customPartNo', 'qty', 'dateCode', 'trackingNo', 'binLevel'],
  [definedLabelType.shixin2.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'dateCode', 'packageType', 'marking', 'binLevel', 'result', 'grossWeight', 'netWeight', 'customPartNo'],
  [definedLabelType.qiangli_box.val]:
    ['productName', 'chipName', 'customPartNo', 'partNo', 'lotNo', 'dateCode', 'trackingNo', 'reserve'],
  [definedLabelType.lianjian.val]:
    ['productName', 'chipName', 'customPartNo', 'partNo', 'purchaseOrderNo', 'dateCode'],
  [definedLabelType.jingyuan_dai.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'customPartNo', 'marking', 'dateCode', 'reserve', 'packageType'],
  [definedLabelType.jingyuan_pian.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'marking', 'reserve', 'packageType'],
  [definedLabelType.jingyuan_box.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'dateCode', 'reserve', 'packageType'],
  [definedLabelType.bag.val]: 
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'dateCode', 'customPartNo', 'marking', 'reserve', 'packageType'],
  [definedLabelType.membrane.val]: 
    ['productName', 'chipName', 'partNo', 'lotNo', 'customPartNo', 'qty', 'packageType'],
  [definedLabelType.case.val]: 
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'dateCode', 'customPartNo', 'marking', 'reserve', 'packageType'],
  [definedLabelType.bagC.val]: 
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'dateCode', 'customPartNo', 'marking', 'reserve', 'packageType'],
  [definedLabelType.moduleNo.val]: 
    ['productName', 'chipName', 'reserve', 'packageType'],
  [definedLabelType.shixinV2.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'trackingNo', 'dateCode', 'packageType', 'marking', 'binLevel', 'result', 'grossWeight', 'netWeight', 'customPartNo', 'reserve'],
  [definedLabelType.hualan.val]:
    ['productName', 'chipName', 'partNo', 'lotNo', 'qty', 'customPartNo', 'reserve', 'marking', 'packageType', 'dateCode', 'purchaseOrderNo', 'processingOrderNo'],
  [definedLabelType.jingtai.val]:
    ['productName', 'chipName', 'reserve', 'customPartNo', 'partNo', 'processingOrderNo', 'qty', 'purchaseOrderNo', 'dateCode'],

};

const defaultCategoryTypes = {
  1: {
    value: 1,
    explain: i18n.t('common.other'),
  },
  2: {
    value: 2,
    explain: i18n.t('common.rowTestDevice'),
  },
  3: {
    value: 3,
    explain: i18n.t('common.columnTestDevice'),
  }
};

const defaultDeviceStatus = {
  1: {
    value: 1,
    explain: i18n.t('common.normal'),
  },
  2: {
    value: 2,
    explain: i18n.t('common.closedBeta'),
  },
  3: {
    value: 3,
    explain: i18n.t('common.forSale'),
  },
  4: {
    value: 4,
    explain: i18n.t('common.scrapped'),
  }
};

const defaultSubDeviceStatus = {
  1: {
    value: 1,
    explain: i18n.t('common.normal'),
  },
  2: {
    value: 2,
    explain: i18n.t('common.closedBeta'),
  },
  102: {
    value: 102,
    explain: '待组装',
  },
  103: {
    value: 103,
    explain: '修改中',
  },
  4: {
    value: 4,
    explain: i18n.t('common.scrapped'),
  }
};

export {
  processTypes,
  priorityLevels,
  storeStatus,
  storeBoxStatus,
  incomingOrderStatus,
  incomeStorageStatus,
  prodOrderStatus,
  orderOprTypes,
  expressages,
  expressageTypes,
  passBinLevels,
  binLevelExplainData,
  partNoSuffixes,
  explainArray,
  labelTypes,
  definedLabelType,
  boxLabelTypes,
  definedFactoryLabelParameter,
  defaultCategoryTypes,
  defaultDeviceStatus,
  defaultSubDeviceStatus,
};
